import React, { Fragment } from "react";
import { authCheckState } from "../../../store/actions/auth";
import { mainLink } from "../../../store/utils";
import axios from "axios";
import Hoc from "../../../hoc/hoc";
import Loading from "../../../components/Loading/index";
import { connect } from "react-redux";
import { Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Divider, FormControlLabel, TextField } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { compose } from "redux";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = (theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "20ch",
    },
  },
});

class Component extends React.Component {
  state = {
    data: [],
    formDisplay: false,
    sayojug_per_day: "",
    saha_sayojug_per_day: "",
    prabidik_karmachari_per_day: "",
    karyalaya_sahayogi_per_day: "",
    trainee_per_day: "",
    loading: false,
  };
  componentDidMount() {
    this.props.authCheckState();
    axios.defaults.headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${this.props.token}`,
    };
    this.setState({ loading: true });
    axios
      .get(mainLink + "/api/v1/costmanagement/")
      .then((res) => {
        this.setState({ loading: false });

        let data = res.data;

        if (res.data !== undefined) {
          this.setState({
            data: res.data,
            sayojug_per_day: data.sayojug_per_day,
            saha_sayojug_per_day: data.saha_sayojug_per_day,
            prabidik_karmachari_per_day: data.prabidik_karmachari_per_day,
            karyalaya_sahayogi_per_day: data.karyalaya_sahayogi_per_day,
            trainee_per_day: data.trainee_per_day,
          });
        }
      })
      .catch((err) => {
        this.setState({ loading: false });

        this.setState({ isErrorDialogPopUp: true, ErrorMessage: err.message });
      });
  }
  // static getDerivedStateFromProps(nextProps, prevState,/* nextProps2,prevState2 */) {
  //   if (nextProps.editions && nextProps.editions !== prevState.data) {
  //     return { data: nextProps.editions };
  //   }
  //   else return null;
  // }

  render() {
    const handleErrorClose = () => {
      this.setState({ isErrorDialogPopUp: false });
    };
    const handelSubmit = (e) => {
      e.preventDefault();
      let data = new FormData();
      data.append("sayojug_per_day", this.state.sayojug_per_day);
      data.append("saha_sayojug_per_day", this.state.saha_sayojug_per_day);
      data.append(
        "prabidik_karmachari_per_day",
        this.state.prabidik_karmachari_per_day
      );
      data.append(
        "karyalaya_sahayogi_per_day",
        this.state.karyalaya_sahayogi_per_day
      );
      data.append("trainee_per_day", this.state.trainee_per_day);

      axios.defaults.headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${this.props.token}`,
      };
      axios
        .post(mainLink + "/api/v1/costmanagement/", data)
        .then((res) => {
          data = res.data;

          if (data.required) {
            document.getElementById(data.required).focus();
          } else if (data.success) {
            alert("सबमिट गरियो");
          }
        })
        .catch((err) => {
          this.setState({
            isErrorDialogPopUp: true,
            ErrorMessage: err.message,
          });
        });
    };
    const { classes } = this.props;
    return this.state.loading ? (
      <Fragment>
        <Loading />
      </Fragment>
    ) : (
      <Fragment>
        <Hoc>
          <Dialog
            open={this.state.isErrorDialogPopUp}
            onClose={handleErrorClose}
            TransitionComponent={Transition}
            // PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
          >
            <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
              Error Message
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                <span
                  style={{ color: "red", fontSize: "small", marginLeft: 20 }}
                >
                  {this.state.ErrorMessage}
                </span>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleErrorClose} color="primary" autoFocus>
                Ok
              </Button>
            </DialogActions>
          </Dialog>
          <Card variant="outlined">
            <div style={{ float: "right", padding: 15 }}>
              {/* <Link to="/admin/costManagement" ><ArrowBackIcon style={{}} /> </Link> */}
            </div>
            <div
              className="font-size-lg font-weight-bold"
              style={{ padding: 10 }}
            >
              लागत व्यवस्थापन
            </div>

            <Divider className="my-1" />
            <CardContent style={{ padding: 5 }}>
              <CardContent
                noValidate
                autoComplete="off"
                className={classes.root}
              >
                <FormControlLabel
                  control={
                    <TextField
                      id="sayojug_per_day"
                      autoFocus
                      defaultValue={this.state.sayojug_per_day}
                      label="सयोजग"
                      type="text"
                      name="money_per_day"
                      value={this.state.sayojug_per_day}
                      style={{ width: "100%" }}
                      onChange={(e) => {
                        this.setState({ sayojug_per_day: e.target.value });
                      }}
                    />
                  }
                />
                <FormControlLabel
                  control={
                    <TextField
                      id="saha_sayojug_per_day"
                      defaultValue={this.state.saha_sayojug_per_day}
                      label="सह सयोजग"
                      type="text"
                      name="money_per_day"
                      value={this.state.saha_sayojug_per_day}
                      style={{ width: "100%" }}
                      onChange={(e) => {
                        this.setState({ saha_sayojug_per_day: e.target.value });
                      }}
                    />
                  }
                />
                <FormControlLabel
                  control={
                    <TextField
                      id="prabidik_karmachari_per_day"
                      defaultValue={this.state.prabidik_karmachari_per_day}
                      label="रबिदिक कर्माचारी"
                      type="text"
                      name="money_per_day"
                      value={this.state.prabidik_karmachari_per_day}
                      style={{ width: "100%" }}
                      onChange={(e) => {
                        this.setState({
                          prabidik_karmachari_per_day: e.target.value,
                        });
                      }}
                    />
                  }
                />
                <FormControlLabel
                  control={
                    <TextField
                      id="karyalaya_sahayogi_per_day"
                      defaultValue={this.state.karyalaya_sahayogi_per_day}
                      label="कार्यालय सहयोगी"
                      type="text"
                      name="money_per_day"
                      value={this.state.karyalaya_sahayogi_per_day}
                      style={{ width: "100%" }}
                      onChange={(e) => {
                        this.setState({
                          karyalaya_sahayogi_per_day: e.target.value,
                        });
                      }}
                    />
                  }
                />
                <FormControlLabel
                  control={
                    <TextField
                      id="trainee_per_day"
                      defaultValue={this.state.trainee_per_day}
                      label="प्रशिक्षार्थि"
                      type="text"
                      name="money_per_day"
                      value={this.state.trainee_per_day}
                      style={{ width: "100%" }}
                      onChange={(e) => {
                        this.setState({ trainee_per_day: e.target.value });
                      }}
                    />
                  }
                />

                <div style={{ width: "500px" }}>
                  {this.props.permissions ? (
                    this.props.permissions.includes("cost-management-edit") && (
                      <Button
                        type="submit"
                        variant="outlined"
                        onClick={handelSubmit}
                      >
                        बुझाउनुहोस्
                      </Button>
                    )
                  ) : (
                    <Button
                      type="submit"
                      variant="outlined"
                      onClick={handelSubmit}
                    >
                      बुझाउनुहोस्
                    </Button>
                  )}
                </div>
              </CardContent>
            </CardContent>
          </Card>
        </Hoc>
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    editions: state.book.editions,
    token: state.auth.token,
    userId: state.auth.userId,
    loading: state.book.loading,
    error: state.book.error,
    isAuthenticated: state.auth.token !== null,
    successAuth: state.auth.successAuth,
    permissions: state.auth.user.permissions,
    hasPermissions: typeof state.auth.user["permissions"] !== "undefined",
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authCheckState: () => dispatch(authCheckState()),
  };
};
export default compose(
  withStyles(useStyles, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps)
)(Component);
